import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import { BulletList, BulletListItem, ImageContainer } from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { Interpolate } from '@doordash/lib-i18n'
import { MotorcycleSafetyVehicleSafetyImage } from '../../images/MotorcycleSafetyVehicleSafetyImage'
import { DOORDASH_AUSTRALIA_STORE_URL } from '../../../../../constants'
import { CommonTextUrl } from '../../../../atoms/common-text-url'

export const MotorcycleVehicleSafetySection = () => {
  return (
    <SectionContainer>
      <ImageContainer>
        <MotorcycleSafetyVehicleSafetyImage />
      </ImageContainer>
      <Text styles={Text.Styles.Bold32}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__online_safety_course__vehicle_safety
        )}
      </Text>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__protective_equipment
        )}
      </Text>
      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__helmets
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__when_riding_you_are_required_by_law_to_wear_an
        )}
      </ContentText>
      <BulletList>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__check_your_helmet_is_the_correct_size_it_should_feel
            )}
          </ContentText>
        </BulletListItem>
      </BulletList>

      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__you_are_also_required_to_wear_a_faceshield_visor_or
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__reflective_gear
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__scooter_and_motorbike_riders_are_vulnerable_road_users_and_must
        )}
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__always_wear_fluorescent_andor_reflective_clothing,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__have_reflective_strips_affixed_to_your_delivery_bags_including_the,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
      <ContentText>
        <Interpolate
          i18n={i18n}
          i18nKey={
            i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__reflective_strips_are_available_in_the_dasher_store_at_doordashaustraliastorecom
          }
          components={[<CommonTextUrl url={DOORDASH_AUSTRALIA_STORE_URL} />]}
        />
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__clothing_and_conditions
        )}
      </Text>
      <BulletList>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__assess_the_road_conditions_to_determine_if_it_is_safe
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__wear_appropriate_nonslip_footwear_reflective_and_high_visibility_clothing_wet
            )}
          </ContentText>
        </BulletListItem>
      </BulletList>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__it_is_recommended_you_wear_clothing_designed_for_motorcycling_as000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__you_should_also_ride_to_the_conditions_even_if_riding001
        )}
      </ContentText>
      <ContentText>
        <Interpolate
          i18n={i18n}
          i18nKey={
            i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__do_not_continue_to_ride_if_conditions_become_unsafe_for002
          }
          components={[
            <Text
              weight={Text.Weights.Bold}
              display={Text.DisplayModes.Inline}
              styles={Text.Styles.SectionSubtext}
            />,
          ]}
        />
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__avoid_hazards_such_as_potholes_and_storm_water_grates_if,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__take_care_when_placing_orders_in_your_bag_that_the,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__load_balance
        )}
      </Text>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__load_balance_while_riding_is_an_important_safety_factor_it,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__take_care_when_placing_orders_in_your_bag_that_the,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
      <ContentText>
        <Interpolate
          i18n={i18n}
          i18nKey={
            i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__in_the_dasher_store_you_can_find_reflective_delivery_bags
          }
          components={[<CommonTextUrl url={DOORDASH_AUSTRALIA_STORE_URL} />]}
        />
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__maintenance
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__before_heading_out_to_complete_deliveries_you_should_complete_a
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__1_check_both_brakes_clutch_and_throttle_are_all_in000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__2_make_sure_there_is_good_pressure_and_tread_across001
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__3_ensure_your_front_rear_and_indicator
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__4_your_mirrors_should_be_fitted_cleanundamaged_and_adjusted_for002
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__scooters_and_motorbikes_should_also_be_subject_to_regular_maintenance003
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__phone_usage
        )}
      </Text>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__although_phones_are_necessary_for_completing_orders_you_should_be,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__while_riding_you_should_use_your_phone_only_for_navigation,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__when_using_navigation_apps_on_your_phone_match_this_to,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
      <ContentText>
        <Interpolate
          i18n={i18n}
          i18nKey={
            i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__phone_mounts_are_available_in_the_doordash_store_at_doordashaustraliastorecom
          }
          components={[<CommonTextUrl url={DOORDASH_AUSTRALIA_STORE_URL} />]}
        />
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__parking_theft
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__always_check_your_local_laws_about_commercial_and_general_motorbike
        )}
      </ContentText>
      <BulletList>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__always_lock_up_your_vehicle_when_it_is_unattended_even
            )}
          </ContentText>
        </BulletListItem>
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__tips_and_road_rules
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__only_ride_once_you_know_and_understand_the_road_rules
        )}
      </ContentText>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__give_yourself_space_dont_follow_too_close_to_other_vehicles,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__check_for_hazards_scan_the_road_for_holes_gaps_uneven,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__avoid_blind_spots_a_blind_spot_is_an_area_outside,
          i18nKeys.safetyCourse_motorcycle_step2__vehicle_safety__dont_rush_the_doordash_system_is_designed_so_that_it,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>
    </SectionContainer>
  )
}
